"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
exports.default = (0, mobx_react_1.observer)(({ field, id = null, value = null }) => (react_1.default.createElement("div", { className: "mt1" },
    react_1.default.createElement("input", Object.assign({}, field.bind({
        id,
        value,
        checked: field.value === value
    }))),
    react_1.default.createElement("label", { htmlFor: id, className: "ml2" }, value),
    react_1.default.createElement("small", { className: "f6 db red" }, field.error))));
